<template>
  <div>
    <LeaseTopComponent
      v-bind:popinfoid="$route.query.popinfo_id"
      v-bind:tsid="$route.query.tsid"
      v-bind:otoken="$route.query.otoken"
      v-bind:x_cls_app_version="$route.query.x_cls_app_version"
      v-bind:x_cls_os="$route.query.x_cls_os"
      v-bind:x_cls_os_version="$route.query.x_cls_os_version"
    >
    </LeaseTopComponent>
  </div>
</template>

<script>
import LeaseTopComponent from '@/components/v2/LeaseTopComponent.vue'
import appVerApi from '@/store/Api/Common/appVer'
import modal from '@/assets/v2/modal'

export default {
  components: {
    LeaseTopComponent
  },
  methods: {
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  async mounted () {
    let isApiError = false

    // webviewメンテナンス情報を取得
    await appVerApi.get().then(res => {
      if (res.data.webviewMaintenance.carLease) {
        this.$router.push({
          name: 'CarCareTopV2',
          query: {
            popinfoid: this.$route.query.popinfo_id,
            tsid: this.$route.query.tsid,
            otoken: this.$route.query.otoken,
            x_cls_app_version: this.$route.query.x_cls_app_version ? this.$route.query.x_cls_app_version : '0.0.0',
            x_cls_os: this.$route.query.x_cls_os ? this.$route.query.x_cls_os : 'iRidge',
            x_cls_os_version: this.$route.query.x_cls_os_version ? this.$route.query.x_cls_os_version : '0.0'
          }
        })
      }
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
  }
}
</script>
